import React from 'react';
import {Row} from 'react-table';
import moment from 'moment';
import {PreleadProject} from 'api';

interface Props {
  row: Row<PreleadProject>;
  value: any;
}

const ProjectGroupCustomizeItemDateCell = ({row, value}: Props) => {
  const preleadProject: PreleadProject = row.original;
  const projectGroupPreleadCustomizeItemId = value;

  const customizeItem = React.useMemo(
    () =>
      preleadProject.prelead.projectGroupCustomizeItemDates.find(
        (item) =>
          item.projectGroupPreleadCustomizeItemId ===
          projectGroupPreleadCustomizeItemId,
      ),
    [preleadProject, projectGroupPreleadCustomizeItemId],
  );
  return customizeItem?.value
    ? moment(customizeItem?.value).format('YYYY年MM月DD日')
    : null;
};

export default ProjectGroupCustomizeItemDateCell;
